'use client';

import styled from '@emotion/styled';

import { shouldForwardProp } from '@hrworks/design-system/utilities';
import { IconButton as _IconButton } from '@hrworks/sui-core/IconButton';

import { mq } from '../../util/mediaQueries';

const Wrapper = styled.div<{ $visible: boolean }>(({ $visible }) => ({
  position: 'fixed',
  // Ueber der sticky Footer-Leiste (Variable setzt Footer.styles.ts ab lg, sonst 0)
  bottom: 'calc(24px + var(--stellenportal-sticky-footer-height, 0px))',
  right: 24,
  zIndex: 1000,
  opacity: $visible ? 1 : 0,
  transform: $visible ? 'scale(1)' : 'scale(0.8)',
  transition: `opacity ${$visible ? '200ms' : '150ms'} ${$visible ? 'ease-out' : 'ease-in'}, transform ${$visible ? '200ms' : '150ms'} ${$visible ? 'ease-out' : 'ease-in'}`,
  pointerEvents: $visible ? 'auto' : 'none',

  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
}));

const IconButton = styled(_IconButton, { shouldForwardProp })(({ theme }) => {
  const userColor = theme.stellenportal?.buttonStyle?.color || theme.eclipseTier2Color.background.brand.bold.default;
  const userTextColor = theme.stellenportal?.buttonStyle?.fontStyle?.color || theme.eclipseTier2Color.text.inverse;

  return {
    // Override CSS variables so sui-core's internal hover uses our color
    '--eclipse-tier2-color-background-brand-bold-hovered': userColor,
    '--eclipse-tier2-color-background-brand-bold-default': userColor,
    width: 48,
    height: 48,
    backgroundColor: userColor,
    color: userTextColor,
    boxShadow: '0 0px 15px rgba(47, 38, 115, 0.3)',
    filter: 'brightness(1)',
    transition: 'filter 200ms ease',

    [mq.supportsHover]: {
      '&&&&:hover, &&&&:active': {
        filter: 'brightness(0.85)',
        backgroundColor: userColor,
      },
    },
  };
});

export const S = {
  Wrapper,
  IconButton,
} as const;
